module.exports = __webpack_public_path__ + "images/services/confluence-page-preview.1f0c797e189e4151c558.svg";